<div class="row" >
	<div class="col-sm-12">
	  <div class="content-header">Client Form</div>
	</div>
  </div>

<div class="card">
    <div class="card-content">
      <div class="card-body">
		<aw-wizard #wizard [navBarLayout]="'large-empty-symbols'">
			<aw-wizard-step [stepTitle]="'Step 1'" [navigationSymbol]="{ symbol: '&#xf007;', fontFamily: 'FontAwesome' }">
				<form #personalForm="ngForm" class="editForm" novalidate>
					<h4 class="head text-center">Personal Details</h4>
					<br/>
					<div class='row'>
						<div class='col-12'>
							<div class="row">
								<div class='col-12 col-sm-6'>
									<div class="form-group">
										<label class="form-control-label" for="firstname">Name</label>
										<input class="form-control input-md" [(ngModel)]="client_model.name" [ngModelOptions]="{standalone: true}" ngModel #firstname="ngModel" required id="firstname" name="firstname" type="text" placeholder="Enter name">
										<small class="form-text text-muted danger" *ngIf="!firstname.valid && (firstname.dirty || firstname.touched)">This field is required!</small>
									</div>
								</div>
								<div class='col-12 col-sm-6'>
									<div class="form-group">
										<label class="form-control-label" for="email">Email</label>
										<input class="form-control input-md" [(ngModel)]="client_model.email" [ngModelOptions]="{standalone: true}" ngModel #email="ngModel" required email id="email" name="email" type="text" placeholder="Enter email">
										<small class="form-text text-muted danger" *ngIf="!email.valid && (email.dirty || email.touched)">Please enter a valid email!</small>
									</div>
								</div>
								<div class='col-12 col-sm-6'>
									<div class="form-group">
										<label class="form-control-label" for="phone">
										  Phone Number <span class="required_field">*</span>
										</label>
										<div class="input-group">
										  <!-- Dropdown for country code -->
										  <div class="input-group-prepend">
											<ng-select
											[(ngModel)]="selected_code"
											[items]="countryCodes"
											bindLabel="label"
											bindValue="value"
											placeholder="Select code"
											required
											id="countryCode"
											name="countryCode"
											>
											</ng-select>
										  </div>
										  <!-- Phone number input field -->
										  <input
											class="form-control input-md"
											[(ngModel)]="client_model.phone"
											[ngModelOptions]="{ standalone: true }"
											ngModel
											#phone="ngModel"
											required
											id="phone"
											name="phone"
											type="text"
											placeholder="e.g. 1234-567-890"
											mask="0000-000-000"
											minlength="10"
										  />
										<!-- </div> -->
									  </div>
									  
									<!-- <div class="form-group">
										<label class="form-control-label" for="phone"
										>Phone Number<span class="required_field">*</span></label
										>
										<div class="input-group">
										<div class="input-group-prepend">
										<span class="input-group-text" id="basic-addon1">+91</span>
										</div>
										<input
										class="form-control input-md" [(ngModel)]="client_model.phone"
										[ngModelOptions]="{standalone: true}"
										ngModel #phone="ngModel" 
										required
										id="phone"
										name="phone"
										type="text" 
										placeholder="e.g. 1234-567-890"  mask="0000-000-000" minlength="10"
										/>
									</div> -->
										<small
										class="form-text text-muted danger"
										*ngIf="
											!phone.valid && (phone.dirty || phone.touched)"
										>Please enter valid Phone number!</small
										>
									</div>
								</div>
								<div class='col-12 col-sm-6'>
									<div class="form-group">
										<label>Location</label>
										<input
										type="text"
										class="form-control"
										id="location" 
										[(ngModel)]="client_model.client_address" [ngModelOptions]="{standalone: true}"
										placeholder="Enter location"
										/> 
									</div>
									<!-- <div class="form-group" *ngIf="client_id">
										<label>Location</label>
										<input
										type="text"
										(keydown.enter)="$event.preventDefault()"
										autocorrect="off"
										autocapitalize="off"
										spellcheck="off"
										class="form-control"
										id="location"
										[(ngModel)]="client_model.address" [ngModelOptions]="{standalone: true}"
										placeholder="Enter location"
										#search/> 
									</div> -->
								</div>
								<div class='col-12 col-sm-6'>
									<div class="form-group">
										<label class="form-control-label">Relationship Manager</label>
										<ng-select
										[items]="emp_list"
										bindLabel="name"
										bindValue="_id"
										[closeOnSelect]="false"
										placeholder="Select Employee"
										[(ngModel)]="client_model.client_representive"
										[ngModelOptions]="{ standalone: true }"
										(change)="getEmpId($event)"
										>
										</ng-select>
											<!-- <input class="form-control input-md" [(ngModel)]="client_model.client_representive" [ngModelOptions]="{standalone: true}" name="source"  type="text" placeholder="Whose connected with client"> -->
									</div>
								</div>
								<!-- <div class='col-12 col-sm-6'>
									<div class="form-group">
										<label class="form-control-label">DOB</label>
										<input class="form-control input-md" [(ngModel)]="client_model.dob" [ngModelOptions]="{standalone: true}" id="dob" name="dob" type="date">
									</div>
								</div> -->
								<div class='col-12 col-sm-6'>
									<div class="form-group">
										<label class="form-control-label">Gender</label>
										<ng-select
										[items]="gender_list"
										bindLabel="name"
										bindValue="_id"
										[closeOnSelect]="false"
										placeholder="Select Gender"
										[(ngModel)]="selected_gender"
										[ngModelOptions]="{ standalone: true }"
										(change)="getGenderId($event)"
										>
										</ng-select>
									</div>
								</div>
								<div class='col-12 col-sm-6'>
									<div class="form-group">
										<label class="form-control-label">Source</label>
										<input class="form-control input-md" [(ngModel)]="client_model.source" [ngModelOptions]="{standalone: true}" name="source"  type="text" placeholder="Enter Source">
									</div>
								</div>
								<div class='col-12 col-sm-6'>
									<div class="form-group">
										<label class="form-control-label">Source Link</label>
											<input class="form-control input-md" [(ngModel)]="client_model.source_link" [ngModelOptions]="{standalone: true}" name="source"  type="text" placeholder="Enter Source">
									</div>
								</div>
							</div>
							
							

							<div class="form-group text-center">
								<button type="button" uiSref="work" class="btn btn-info" [disabled]="!personalForm.valid" awNextStep>
									Next
									<span style="margin-left:10px;">
										<i class="ft-chevron-right"></i>
									</span>
								</button>
							</div>
						</div>
					</div>
				</form>
			</aw-wizard-step>
			<aw-wizard-step  [stepTitle]="'Step 2'" [navigationSymbol]="{ symbol: '&#xf0b1;', fontFamily: 'FontAwesome' }">
				<form #workForm="ngForm" class="editForm" novalidate>
					<h4 class="head text-center">Professional Details</h4>
					<br/>
					<div class='row'>
						<div class='col-12 col-sm-6'>
							<div class="form-group">
								<label class="form-control-label">Client Type</label>
								<ng-select
									[items]="channel_list"
									bindLabel="displayname"
									bindValue="_id"
									[closeOnSelect]="false"
									placeholder="Select Client Type"
									[(ngModel)]="selected_channel"
									[ngModelOptions]="{ standalone: true }"
									(change)="getChannelId($event)"
									>
								</ng-select>
							</div>
						</div>
						<div class='col-12 col-sm-6'>
							<div class="form-group">
								<label class="form-control-label">History</label>
								<input class="form-control input-md" [(ngModel)]="client_model.history" [ngModelOptions]="{standalone: true}" ngModel #history="ngModel"  history id="history" name="history" type="text" placeholder="Enter history">
							</div>
						</div>
						<div class='col-12 col-sm-6'>
							<div class="form-group">
								<label class="form-control-label">Business / Contract</label>
								<ng-select [items]="business_list" bindLabel="name" bindValue="_id" placeholder="Select Business"
									[(ngModel)]="selected_business" [ngModelOptions]="{ standalone: true }"
									(change)="getBusinessId($event)" (search)="getAllBusiness($event,'')">
								</ng-select>
							</div>
						</div>
						<div class='col-12 col-sm-6'>
							<div class="form-group">
								<label class="form-control-label">Documents</label>
								<input class="form-control input-md" [(ngModel)]="client_model.documents" [ngModelOptions]="{standalone: true}" ngModel #documents="ngModel"  documents id="documents" name="documents" type="text" placeholder="Enter documents">
							</div>
						</div>
						<div class='col-12 col-sm-6'>
							<div class="form-group">
								<label class="form-control-label">Payment Info</label>
								<!-- <input class="form-control input-md" [(ngModel)]="client_model.bankinfo" [ngModelOptions]="{standalone: true}" ngModel #bankinfo="ngModel"  bankinfo id="bankinfo" name="bankinfo" type="text" placeholder="Enter bank info"> -->
								<textarea class="form-control" name="bankinfo" id="bankinfo" cols="30" rows="3" [(ngModel)]="client_model.bankinfo" [ngModelOptions]="{standalone: true}" placeholder="Enter payment info"></textarea>
							
							</div>
						</div>
						<div class='col-12 col-sm-6'>
							<div class="form-group">
								<label class="form-control-label">Notes</label>
								<!-- <textarea class="form-control"  name="notes" id="notes" cols="30" rows="3" [(ngModel)]="client_model.notes" [ngModelOptions]="{standalone: true}" placeholder="Enter notes"></textarea> -->
								<quill-editor (onContentChanged)="inlineAddupdateBody(client_model.notes,'notes')" [(ngModel)]="client_model.notes"
                        		[ngModelOptions]="{standalone: true}">
                      
                      			</quill-editor>
							</div>
						</div>
						<div class='col-12 col-sm-6'>
							<div class="form-group" style="margin-top: -248px !important;">
								<label class="form-control-label">Admin Notes</label>
								<!-- <textarea class="form-control" name="admin_notes" id="admin_notes" cols="30" rows="3" [(ngModel)]="client_model.admin_notes" [ngModelOptions]="{standalone: true}" placeholder="Enter admin notes"></textarea> -->
								<quill-editor (onContentChanged)="inlineAddupdateBody(client_model.admin_notes,'admin_notes')" [(ngModel)]="client_model.admin_notes"
                        			[ngModelOptions]="{standalone: true}">
                      			</quill-editor>
							</div>
						</div>
					</div>
					<div class="form-group text-center space-20">
						<button uiSref="personal" type="button" class="btn btn-secondary mr-1" awPreviousStep>
							<span style="margin-right:10px;">
								<i class="ft-chevron-left"></i>
							</span> Previous</button>
							<button uiSref="result" type="button" class="btn btn-success" [disabled]="!workForm.valid" awResetWizard (click)="submit()">
								Finish
								<span style="margin-left:10px;">
									<i class="ft-chevron-right"></i>
								</span>
							</button>
					</div>
				</form>
			</aw-wizard-step>
		</aw-wizard>
	  </div>
	</div>
</div>
<div class="d-flex justify-content-between align-items-center">
    <ngx-spinner></ngx-spinner>
</div>